import { useNavigate, useLocation } from 'react-router-dom';
import { usePermissions } from '@/hooks/usePermissions';

export default function RRHHLayout({ user, onLogout, children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { hasPermission, isAdmin } = usePermissions(user);

  const allTabs = [
    { name: 'Base Datos Trabajadores', path: '/rrhh', permission: 'agricultura.rrhh.trabajadores.view' },
    { name: 'Control de Asistencia', path: '/rrhh/asistencia', permission: 'agricultura.rrhh.asistencia.view' },
    { name: 'Historial Disciplinario y Legal', path: '/rrhh/historial-disciplinario', permission: 'agricultura.rrhh.disciplinario.view' },
  ];

  // Filtrar tabs según permisos
  const tabs = isAdmin ? allTabs : allTabs.filter(tab => hasPermission(tab.permission));

  return (
    <div>
      {/* Sub-tabs for R.R.H.H. - Responsive con scroll horizontal automático */}
      <div className="bg-gray-100 dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="mobile-tab-scroll -mx-4 sm:-mx-6 lg:-mx-8 px-4 sm:px-6 lg:px-8">
            <div className="flex gap-1 sm:gap-4 min-w-max">
              {tabs.map((tab) => {
                const isActive = location.pathname === tab.path;
                return (
                  <button
                    key={tab.path}
                    onClick={() => navigate(tab.path)}
                    className={`
                      px-3 sm:px-4 py-3 text-xs sm:text-sm font-medium transition-colors whitespace-nowrap shrink-0
                      ${isActive
                        ? 'text-emerald-600 border-b-2 border-emerald-600'
                        : 'text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white border-b-2 border-transparent'
                      }
                    `}
                    data-testid={`rrhh-tab-${tab.path.split('/').pop() || 'trabajadores'}`}
                  >
                    {tab.name}
                  </button>
                );
              })}
            </div>
          </nav>
        </div>
      </div>

      {/* Content */}
      <div className="dark:text-white">
        {children}
      </div>
    </div>
  );
}
